(ns com.theplantscape.plant-web.draw.db
  (:require
   [com.theplantscape.local-store.ensemble
    :refer [diag
            fetch-diagram-plants
            fetch-diagram-settings
            placed-plants
            select-plant
            select-structure]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state diagram-settings site-data]]
   [datascript.core :as d]
   [reagent.core :as r]))

(defn fetch-diagram-settings-form []
  (let [settings (fetch-diagram-settings)]
    (swap! app-state assoc-in [:diagram :settings :values] settings)
    (swap! app-state assoc-in [:diagram :settings :values] settings)
    (diagram-settings :hide)))

(defn register-querys
  ([query-map]
   ;; Set initial values, then only change when the tx report changes
   (swap! site-data assoc-in [:datalog-queries]
          (reduce (fn update-queries [m [k v]]
                    (assoc m k (apply (first v) (rest v))))
                  {}
                  query-map))

   (d/listen! diag key
              (fn [tx-report]
                ;; Only update if data was modified
                (prn "data modified")
                (when (:tx-data tx-report)
                  (swap! site-data assoc-in [:datalog-queries]
                         (reduce (fn update-queries [m [k v]]
                                   ;;(prn (str "update registered querys ") k)
                                   (assoc m k (apply (first v) (rest v))))
                                 {}
                                 query-map)))))

   (set!  (.-__key ^js site-data) "diagram-queries")))

(defn register-query
    ([hm-key query] (register-query hm-key query nil))
    ([hm-key query params]
   ;; Set initial values, then only change when the tx report changes
     (swap! site-data assoc-in [:datalog-queries hm-key] (apply query params))
     (d/listen! diag hm-key
                (fn [tx-report]
                  ;;(prn (str "register query update query " hm-key))
                  ;; Only update if data was modified
                  (when (:tx-data tx-report)
                    (swap! site-data assoc-in [:datalog-queries hm-key] (apply query params)))))
     (set!  (.-__key ^js site-data) query)))

(defn register-queries []
  (register-query :boundary fetch-diagram-settings [:area])
  (register-query :patch select-structure [:patch])
  (register-query :area select-structure [:area])
  (register-query :structure select-structure [:structure])
  (register-query :path select-structure [:path])
  (register-query :family select-plant [:family])

  (register-query :canopy select-plant [:canopy])
  (register-query :sub-canopy select-plant [:sub-canopy])
  (register-query :shrub select-plant [:shrub])
  (register-query :vine select-plant [:vine])
  (register-query :ground select-plant [:ground])
  (register-query :herbaceous select-plant [:herbaceous])
  (register-query :root select-plant [:root])

  ;; select all plants here
  (register-query :plants fetch-diagram-plants []))

(defn select-bind
  "Watch for transactions to the database, update atom on change."
  ([q] (select-bind q select-plant))
  ([q query] (select-bind q query (r/atom nil)))
  ([q query state]
   ;; this should be a param / unique key for the bind
   (let [k "test-random"]
     (reset! state (query q))
     (d/listen! diag q
                (fn [tx-report]
                  ;; (prn (str "select bind update query " key))
                  ;; Only update if data was modified
                  (when (:tx-data tx-report)
                    (reset! state (query q)))))
     ;(reset! state k)
     (set!  (.-__key ^js state) q)
     state)))

(defn placed-plants-bind
  "Watch for transactions to the database, update atom on change."
  ([]
   (placed-plants-bind (r/atom nil)))
  ([state]
   ;; this should be a param / unique key for the bind
   (let [db-query-key :db-placed-plants-update]
     (reset! state (placed-plants))
     (d/listen! diag db-query-key
                (fn [tx-report]
                  ;; (prn (str "placed plants bind update query " key))
                  ;; Only update if data was modified
                  (when (:tx-data tx-report)
                    (reset! state (placed-plants)))))

     (set! (.-__key ^js state) db-query-key)
     ;(reset! state db-query-key)
     state)))

(comment (register-queries)
         (select-plant :canopy)
         (count (select-plant :sub-canopy)))

